/**
 * Application configuration
 */

// Debug flags - toggle true/false
export const IS_SHOW_AUTH_DEBUG = false

export const SHOW_MOCK_OFFSETS = false
export const IS_SHOW_STARTPARAM_DEBUG = false
export const SHOW_APPLE_PAY = false

/**
 * Logging utilities (optional)
 */
export const debugUtils = {
  /**
   * Auth logging
   */
  authLog: (message: string, ...args: unknown[]) => {
    if (IS_SHOW_AUTH_DEBUG) {
      console.log(message, ...args)
    }
  },
}
